<template>
  <div>
    <div>
      <reg-input
        :value.sync="telphone"
        placeholder="请输入您的手机号"
        ref="telphone"
      />
    </div>

    <ld-button
      :loading="submiting"
      :disabled="!validSuccess"
      class="submit-btn"
      @click.native="submit"
      main2
      size="lg"
    >
      {{ $t('B005','下一步') }}
    </ld-button>
    <!--  -->
    <choose-corp
      ref="corp"
      btn-text="获取验证码"
      :comp-list="compList"
      @selected="corpChecked"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import regInput from 'Views/User/Register/reg-input'
import ldButton from 'Common/ldButton'
import { validators } from 'Utils/valid'
import { ifStrBlank } from 'Utils/string'
import {  localset } from 'Utils/storage.js'
import chooseCorp from 'Views/User/Login/chooseCorp'

export default {
  components: {
    regInput,
    ldButton,
    chooseCorp
  },
  data () {
    return {
      validators,
      submiting: false,
      telphone: '',
      compList:[]
    }
  },
  mounted () {
    this.$store.commit('ResetPassword/SET_STEP', 1)
    
    if (this.$store.state.ResetPassword.telphone) {
      this.$refs.telphone.focusEvent()
    }
  },
  methods: {
    // 选中企业
    corpChecked(compId,corpId,remember){
      if(compId){
        this.loginConfig.compaySuper=compId
      }
      this.corpId=corpId
      this.remember=remember
      if(this.remember){
        localset('lastRemember',{corpId:corpId,compId:this.loginConfig.compaySuper})
      }
      this.submit()
    },
    getCorpData(){
      let params = {
        'compId': this.loginConfig.compaySuper,
        'loginType': 1,
        'loginName': this.telphone,
        'password': '',
        'validateCode': '',
        'validateCodeId': '',
      }
      var self=this
      this.$store.dispatch('getCorpList', params).then(({item,msg}) => {
        if(Array.isArray(item)){
          if(item.length==1){
            var comp=item[0]
            if(comp.vipCorpList.length==1){
              self.corpChecked(comp.companyId,comp.vipCorpList[0].corpId,false)
            }else{
              self.compList=item
              self.$refs.corp.toggle()
            }
          }else{
            self.compList=item
            self.$refs.corp.toggle()
          }
        }else{
          self.$toast(msg)
        }
      })
    },
    submit () {
      let valider = validators.mobile(this.telphone)
      if (!valider.valid) {
        this.$validErrorTips(valider.msg)
        return
      }

      if(!this.loginConfig.compaySuper){
        this.getCorpData()
        return
      }

      this.submiting = true
      this.$api['user/smsCodeGet']({
        compId: this.loginConfig.compaySuper,
        phoneNumber: this.telphone,
        type: '找回密码'
      }).then(() => {
        this.submiting = false
        this.$store.commit('ResetPassword/SET_TELPHONE', this.telphone.trim())
        this.$router.push('/resetPassword/secondStep')
      }).catch(() => {
        this.submiting = false
      })
    }
  },
  computed: {
    ...mapGetters(['loginConfig']),
    validSuccess: function() {
      return !ifStrBlank(this.telphone)
    }
  }
}
</script>


